export default class GridHelpersService {
    constructor() {
        this.sections = ['main', 'deploymentFrequency', 'leadTime', 'changeVolume','activities'];
        this.gridWidth = 8;
    }

    getMainWidth(mainSettings) {
        return Object.getOwnPropertyNames(mainSettings).reduce((acc, val) => {
            acc = acc + (mainSettings[val].visible ? 1 : 0);
            return acc;
        }, 0);
    }

    getWidgetWidth(display) {
        switch (display) {
            case 'all':
                return 4;
            case 'summary':
                return 1;
            case 'graph':
                return 3;
            case 'none':
                return 0;
        }
    }

    getHeight(name) {
        return name === 'main' ? 1 : 3;
    }

    getWidthOfWidget(name, settings) {
        if (name === 'main') {
            return this.getMainWidth(settings.main);
        } else if (name === 'activities') {
            return settings.activities.size.width;
        } else {
            return this.getWidgetWidth(settings[name].display);
        }
    }

    getHeightOfWidget(name, settings) {
        if (name === 'main') {
            return 1;
        } else if (name === 'activities') {
            return settings.activities.size.height;
        } else {
            return 3;
        }
    }

    adjustPositions(settings, addedSections = []) {
        const positions = this.sections.filter(s => settings[s].visible || settings[s].display !== 'none')
            .map(s => ({ name: s, position: settings[s].position }))
            .sort((a, b) => a.position.row * 8 + a.position.column - b.position.row * 8 + b.position.column);
        positions.forEach(item => {
            const width = this.getWidthOfWidget(item.name, settings);
            if (item.position.column + width > this.gridWidth) {
                // need to adjust
                const newColumn = this.gridWidth - width;
                item.position.column = newColumn;

                // moving all elements on specific rows count to bot
                const rowsToMove = this.getHeightOfWidget(item.name, settings);
                positions.forEach(a => {
                    if (a.position.row >= item.position.row && a.name !== item.name) {
                        a.position.row = a.position.row + rowsToMove;
                    }
                });
            }
        });
        if (positions.length > 1) {
            let widgetA, widgetB, diff, posA, posB;
            for (let i = 0; i < positions.length - 1; i++) {
                posA = positions[i];
                posB = positions[i + 1];
                // compare items
                widgetA = { position: posA.position };
                widgetA.size = {
                    height: this.getHeightOfWidget(posA.name, settings),
                    width: this.getWidthOfWidget(posA.name, settings)
                };
                widgetB = { position: posB.position };
                widgetB.size = {
                    height: this.getHeightOfWidget(posB.name, settings),
                    width: this.getWidthOfWidget(posB.name, settings)
                };
                if (this.areIntersected(widgetA, widgetB)) {
                    if (posB.position.row >= posA.position.row && addedSections.indexOf(posA.name) === -1) {
                        posB.position.row = posA.position.row + widgetA.size.height;
                    } else {
                        posA.position.row = posB.position.row + widgetB.size.height;
                    }
                }
            }
        }
        this.sections.forEach(s => {
            const setting = settings[s];
            if (setting.visible || setting.display !== 'none') {
                setting.position = positions.find(p => p.name === s).position;
            }
        });
        return settings;
    }

    areIntersected(widgetA, widgetB) {
        const ax1 = widgetA.position.column;
        const ay1 = widgetA.position.row;
        const ay2 = ay1 + widgetA.size.height;
        const ax2 = ax1 + widgetA.size.width;

        const bx1 = widgetB.position.column;
        const by1 = widgetB.position.row;
        const by2 = by1 + widgetB.size.height;
        const bx2 = bx1 + widgetB.size.width;
        return ((bx1 <= ax1 && ax1 < bx2) || (ax1 <= bx1 && bx1 < ax2)) && ((by1 <= ay1 && ay1 < by2) || (ay1 <= by1 && by1 < ay2));
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/grid-helpers/grid-helpers.service.js